(function ($) {
    "use strict";
    var defaultOpts = {
        textarea: $('#editor'),
        toolbar: [
            'title', 'bold', 'italic', 'underline', 'strikethrough', 'color', '|', 'ol', 'ul', 'alignment', 'blockquote', '|', 'sup', 'sub', '|', 'link', 'image', 'video', 'html', 'preview'
        ],
        placeholder: '       ',
        toolbarFloatOffset: 0,
        toolbarFloat: true,
        cleanPaste: false,
        tabIndent: false,
        // imageButton:['upload','external'],
        imageButton: ['upload'],
        pasteImage: false,
        allowedAttributes: {
            img: ['src', 'alt', 'data-non-image','data-image-size']
        },
        defaultImage: '/vendors/images/loading.gif',
        upload: {
            // url: '/meeting/upload/?editorid=myEditor',
            url: '/upload/upload/',
            fileKey: 'files',
            connectionCount: 3,
            leaveConfirm: '上传正在进行中，你确定要离开这个页面吗?'
        }
    };
    var _initSimditor = function (opts) {
        var _opts = $.extend({}, defaultOpts, opts);

        _opts.textarea = $(this);
        var simditor = new Simditor(_opts);

        simditor.on("valuechanged", function (e) {
            var _contxtLen = e.target.body.text().length;

            _opts.valuechanged && _opts.valuechanged(e, e.target.body);
            if (typeof _opts.getValueSize === 'function') {
                _opts.getValueSize(_contxtLen);
            }
        })
        return simditor;
    };

    $.fn.initSimditor = function (options) {
        return _initSimditor.call(this, options)
    };
})(jQuery);